import { TransactionType, } from '../../shared/index.js';
export var isStarknetTransaction = function (transaction) {
    return transaction.type === TransactionType.STARKNET;
};
//# sourceMappingURL=starknet.js.map